import React from "react";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const feedbacks = [
  {
    video: "/videos/cliente1-h264.mp4",
    poster: "/images/cliente1.png",
    frase: "Como pai, aquilo que eu vejo, é que existe uma grande empatia entre o Diogo e o Guilherme..."
  },
  {
    video: "/videos/cliente2-h264.MP4",
    poster: "/images/cliente2.png",
    frase: "A principal diferenca, sem duvida, é a minha disposição no treino da minha modalidade!"
  },
  {
    video: "/videos/cliente3-h264.MP4",
    poster: "/images/cliente3.png",
    frase: "Tenho uma saude divinal! E agradecer ao Diogo mais uma vez..."
  },
  {
    video: "/videos/cliente4-h264.mp4",
    frase: "De facto o trabalho que tenho feito aqui com o Diogo tem sido muito bom!"
  },
  {
    video: "/videos/cliente5-h264.mp4",
    frase: "O Diogo faz-nos sentir bem, e esforcarmo-nos!"
  },
  {
    video: "/videos/cliente6-h264.mp4",
    frase: "Movimento-me muito melhor!"
  },
  {
    image: "/images/cliente4.jpg",
    frase: "Tem sido muito bom..."
  }
];

function Feedback() {
  return (
    <section className="py-16 px-8 bg-[#012326] text-white min-h-screen">
      <h2 className="text-3xl font-bold text-center mb-12 text-[#BFAE99]">Feedback</h2>
      <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
        {feedbacks.map((item, index) => (
          <div key={index} className="flex flex-col items-center space-y-4">
            {item.video ? (
              <video
                className="w-full h-[600px] border-4 border-gray-300 rounded-lg opacity-75 object-cover"
                src={item.video}
                poster={item.poster}
                loop
                muted
                playsInline
                controls
              ></video>
            ) : (
              <img
                src={item.image}
                alt={`Feedback ${index + 1}`}
                className="w-full h-[600px] border-4 border-gray-300 rounded-lg opacity-75 object-cover"
              />
            )}
            <p className="text-center italic text-lg indent-8">"{item.frase}"</p>
          </div>
        ))}
      </div>

      {/* Botão de Contacto */}
      <div className="mt-16 text-center">
        <a
          href="/contact"
          className="inline-block px-6 py-3 bg-[#BFAE99] text-[#012326] font-semibold rounded-lg hover:bg-white transition-colors duration-300"
        >
          Contacte-nos!
        </a>
      </div>

      {/* Redes Sociais */}
      <div className="mt-16 text-center">
        <p className="text-lg mb-4">Para ver mais vídeos e feedbacks, aceda às nossas redes sociais:</p>
        <div className="flex justify-center space-x-8">
          <a
            href="https://www.instagram.com/mindstudiosetubal_/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#BFAE99] hover:text-white transition-colors duration-300"
            aria-label="Instagram"
          >
            <FaInstagram className="text-3xl" />
          </a>
          <a
            href="https://www.tiktok.com/@mindstudiosetubal"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#BFAE99] hover:text-white transition-colors duration-300"
            aria-label="TikTok"
          >
            <FaTiktok className="text-3xl" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default Feedback;
